import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Badge, Form, FormGroup, Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Button from "../../../components/Button/Button";
import ErrorMessage from "./../../../helpers/ErrorMessage/ErrorMessage";
import Icon from "../../../components/Icon/Icon";
import {
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
} from "../../../components/Block/Block";
import { authContext } from "./../../../context/AuthContext/AuthContext";
import {
  loginUserValidation,
  verifyPhoneNumberOTPValidation,
} from "./../../../utils/validation/validation";

const LogInAuth = () => {
  const loader = useSelector((state) => state.loader);

  const { handleLogIn } = useContext(authContext);

  // Validation
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginUserValidation),
  });

  return (
    <>
      <SiteTitle title="ورود به حساب کاربری" />

      <BlockHead>
        <BlockContent className="text-center">
          <BlockTitle tag="h4">ورود به حساب کاربری</BlockTitle>
          <BlockDes>
            <p>
              برای ورود به <b className="text-primary">پنل کاربری</b> رفاهی تو
              اطلاعات خود را وارد نمایید
            </p>
          </BlockDes>
        </BlockContent>
      </BlockHead>
      <Form className="is-alter" onSubmit={handleSubmit(handleLogIn)}>
        <FormGroup>
          <div className="form-label-group">
            <label className="form-label" htmlFor="phoneNumber">
              شماره موبایل
            </label>
          </div>
          <div className="form-control-wrap">
            <input
              type="number"
              placeholder="شماره موبایل خود را وارد نمایید"
              className="form-control-lg form-control"
              {...register("phoneNumber")}
            />

            <ErrorMessage message={errors.phoneNumber?.message} />
          </div>
        </FormGroup>
        <FormGroup>
          <div className="form-label-group">
            <label className="form-label" htmlFor="password">
              کلمه عبور
            </label>
            <Link
              className="link link-primary link-sm"
              to="/auth/forget-password"
            >
              کلمه عبور خودرا فراموش کردید؟
            </Link>
          </div>
          <div className="form-control-wrap">
            <input
              type="password"
              id="password"
              placeholder="کلمه عبور خودرا وارد نمایید"
              className="form-control-lg form-control"
              {...register("password")}
            />

            <ErrorMessage message={errors.password?.message} />
          </div>
        </FormGroup>
        <FormGroup>
          <Button
            size="lg"
            className="btn-block"
            type="submit"
            loading={loader}
            color="primary"
          >
            ورود
          </Button>
        </FormGroup>
      </Form>
      {/* <div className="form-note-s2 text-center pt-4">
        حساب کاربری ندارید؟{" "}
        <Link to="/auth/register/admin">ایجاد حساب کاربری</Link>
      </div> */}
      <Verified phoneNumber={watch("phoneNumber")} />
    </>
  );
};

export default LogInAuth;

const Verified = ({ phoneNumber }) => {
  const loader = useSelector((state) => state.loader);

  const { isSendCode, setIsSendCode, handleVerifyPhoneNumberOTP } =
    useContext(authContext);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(verifyPhoneNumberOTPValidation),
  });

  useEffect(() => {
    if (!!phoneNumber) setValue("phoneNumber", phoneNumber);
    setValue("otp", "");
  }, [phoneNumber, isSendCode]);

  return (
    <Modal
      isOpen={!!isSendCode}
      className="modal-dialog-centered"
      size="sm"
      toggle={() => setIsSendCode(false)}
    >
      <ModalBody>
        <span
          type="button"
          onClick={() => setIsSendCode(false)}
          className="close"
        >
          <Icon name="cross-sm" />
        </span>
        <div className="p-2">
          <h5 className="title">تایید شماره موبایل</h5>
          <br />
          <Form
            className="is-alter"
            onSubmit={handleSubmit(handleVerifyPhoneNumberOTP)}
          >
            <FormGroup>
              <div className="form-label-group">
                <label className="form-label" htmlFor="otp">
                  کد تایید
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="number"
                  placeholder="کد تایید خود را وارد نمایید"
                  className="form-control-lg form-control"
                  {...register("otp")}
                />

                <ErrorMessage message={errors.otp?.message} />
              </div>
            </FormGroup>

            <p className="text-center">
              زمان باقی مانده :{" "}
              <Badge
                id="otpCountdown"
                className="badge-dim font-weight-bold"
                color="primary"
              >
                120
              </Badge>{" "}
              ثانیه
            </p>
            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
              <li>
                <Button
                  color="primary"
                  size="lg"
                  type="submit"
                  loading={loader}
                >
                  تایید شماره موبایل
                </Button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => setIsSendCode(false)}
                  className="link link-light"
                >
                  انصراف
                </button>
              </li>
            </ul>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  );
};
